import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMenuAIAutomationLayoutContext } from 'widgets/Menu/ui/MenuAIAutomation'
import { KeywordPageStore } from 'pages/keywords'
import { KeywordsPageContext } from '../context/keywordsPageContext'

export const KeywordsPageLayout = observer(() => {
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const entities = useEntitiesContext()
  const [keywordsStore] = useState(
    () => new KeywordPageStore(menuLayoutStore.pageLayoutStore, entities)
  )

  return (
    <KeywordsPageContext.Provider value={keywordsStore}>
      <Outlet />
    </KeywordsPageContext.Provider>
  )
})
